export const API_BASE = process.env.REACT_APP_API_BASE;

export const FIREBASE_CONVERSATIONS = "conversations_v3";
export const FIREBASE_JOURNAL_THREADS = "shared_journal_threads";
